// Dependencies
import React, { useState } from "react"
import { Image } from "@unpic/react"

function ImageGallery({ images, caption = "" }) {
  const [index, setIndex] = useState(0)

  const handleClick = () => {
    setIndex(i => {
      if (i === images.length - 1) {
        return 0
      } else {
        return i + 1
      }
    })
  }

  return (
    <div className="image-gallery-wrapper">
      <div className="image-gallery" onClick={handleClick}>
        {images.map((image, i) => {
          // Random rotation between -4 and 4
          const rotation = Math.random() * 8 - 4
          const active = i === index
          return (
            <div
              className={`image-gallery-image ${active ? "active" : ""}`}
              style={{
                transform: !active
                  ? `rotate(${rotation}deg) scale(1.05)`
                  : `rotate(0deg) scale(1)`,
              }}
              key={i}
            >
              <Image
                src={`${image.file.url}?w=1440&q=75&fm=webp`}
                alt={image.description}
              />
            </div>
          )
        })}
      </div>
      <div className="image-gallery-description flex-spaced">
        {caption && <span>{caption}</span>}{" "}
        <span>
          {index + 1} / {images.length}
        </span>
      </div>
    </div>
  )
}

export default ImageGallery
